import { ScrollArea } from '@app/shared/ui/atoms/Common';
import { TopBar } from '@app/shared/ui/molecules/Common';
import { DepositSection, SettlementMarketList } from '@app/shared/ui/organisms/Settlements';
import { useDepositSection } from '@app/shared/hooks/useDepositSection';
import { PriceType } from '@app/shared/types/common';
import { PackCarousel } from '@app/shared/ui/molecules/Shop';

export default function SettlementsPage() {
  const {
    amount,
    scrollRef,
    setAmount,
    isPolling,
    handleTopUp,
    handleSetAmountAndScroll,
    walletAddress,
    isSuccessful,
    isLocked,
    isWallet,
  } = useDepositSection(PriceType.TON);

  return (
    <ScrollArea className="gap-4">
      <TopBar />
      <DepositSection
        amount={amount}
        onAmountChange={setAmount}
        isTopUpDisabled={!amount || isPolling || !walletAddress}
        onTopUpBtnClick={handleTopUp}
        scrollRef={scrollRef}
        isSuccessful={isSuccessful}
        isLocked={isLocked}
        isWallet={isWallet}
      />
      <div className="-ml-[90px]">
        <PackCarousel onPackClick={handleSetAmountAndScroll} />
      </div>
      <SettlementMarketList onSettlementClick={handleSetAmountAndScroll} />
    </ScrollArea>
  );
}
